import { connect } from 'react-redux'

import { Avatar } from '@mui/material'
import { selectAuthUserPicture, StoreWithSession } from '../../index'

const ProfilePictureView = ({
  fill = undefined,
  picture,
  size,
}: {
  fill?: string
  picture?: string
  size?: number
}) => <Avatar src={picture} sx={{ height: size, width: size, bgColor: fill }} />

const mapStateToProps = (state: StoreWithSession) => ({
  picture: selectAuthUserPicture(state),
})

export const ProfilePicture = connect(mapStateToProps)(ProfilePictureView)
